<template>
    <div>
        <preloginheader></preloginheader>
<preloginMain @openbottomsheet="AppDialog = true"></preloginMain>
<preloginbottomsheet v-if="$vuetify.breakpoint.width < 600" :appDialog="AppDialog" @closeAppDialog="AppDialog = false"></preloginbottomsheet>
    </div>
</template>
<script>
import preloginMain from './prelogincomponents/prelogin.vue';
import preloginheader from './prelogincomponents/preloginheader.vue';
import preloginbottomsheet  from './prelogincomponents/prologinbottomsheet.vue'
export default{
    data(){
        return{
AppDialog:false
        }
    },
    components:{
        preloginMain,preloginheader,preloginbottomsheet
    },
    mounted(){
        this.AppDialog = true
    }
}
</script>